import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributorProfileComponent } from './containers/distributor-profile/distributor-profile.component';
import { DistributorInfoComponent } from './components/distributor-info/distributor-info.component';
import {
  MatCardModule,
  MatFormFieldModule
} from '@angular/material';
import { DistributorService } from './services/distributor.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { EmployeeListComponent } from './components/employee-list/employee-list.component';
import { DealerListComponent } from './components/dealer-list/dealer-list.component';
import { TrainingComponent } from './components/training/training.component';
import { DealerInfoComponent } from './components/dealer-info/dealer-info.component';
import { DistributorComponent } from './distributor.component';
import { Routes, RouterModule } from '@angular/router';
import { DealerProfileComponent } from './containers/dealer-profile/dealer-profile.component';
import { DealerViewComponent } from './containers/dealer-view/dealer-view.component';
import { EmployeeProfileComponent } from './containers/employee-profile/employee-profile.component';
import { EmployeeInfoComponent } from './components/employee-info/employee-info.component';
import { CourseEnrollmentComponent } from './components/course-enrollment/course-enrollment.component';
import { EmployeeEditComponent } from './components/employee-edit/employee-edit.component';
import { OpportunityMeetingComponent } from './components/opportunity-meeting/opportunity-meeting.component';
import { SelectDealerComponent } from './components/select-dealer/select-dealer.component';
import { AuthInterceptor } from "./services/auth-interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { DistributorErrorHandler } from "./services/distributor-error-handler";
import { NotificationService } from "./services/notification-service";
import { ErrorInterceptor } from "./services/error-interceptor";
import { AdaService } from '../shared/services/ada.service';

// const routes: Routes = [
//   {
//     path: '',
//     component: DistributorComponent
//   },
//       {
//         path: 'distributor/profile',
//         component: DistributorProfileComponent
//       },
//       {
//         path: 'dealer/view',
//         component: DealerViewComponent
//       },
//       {
//         path: 'dealer/profile',
//         component: DealerProfileComponent
//       },
//       {
//         path: 'employee/profile',
//         component: EmployeeProfileComponent
//       },
// ]

const MATERIAL_COMPONENTS = [MatCardModule, MatFormFieldModule];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ...MATERIAL_COMPONENTS,
    // RouterModule.forRoot(routes)
  ],
  declarations: [DistributorProfileComponent, DistributorInfoComponent, EmployeeListComponent, DealerListComponent, TrainingComponent, DealerInfoComponent, DistributorComponent,
    DealerProfileComponent, DealerViewComponent, EmployeeProfileComponent, EmployeeInfoComponent, CourseEnrollmentComponent, EmployeeEditComponent, OpportunityMeetingComponent, SelectDealerComponent,
    // ModalComponent // this declaration needs to be moved into a shared component module
  ],
  providers: [
    NotificationService,
    {
      provide : HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi   : true,
    },
    {
      provide : HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi   : true,
    },
    // {
    //   provide: ErrorHandler,
    //   useClass: DistributorErrorHandler,
    //   multi: false
    // },
    DistributorService,
    AdaService
  ],
  exports: [DistributorComponent, DistributorProfileComponent, DealerProfileComponent, EmployeeProfileComponent, DealerViewComponent],
  entryComponents: [DistributorProfileComponent, DealerViewComponent, DealerProfileComponent, EmployeeProfileComponent]
})
export class DistributorModule { }



// WEBPACK FOOTER //
// ./src/app/distributor/distributor.module.ts